var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"NotFound__Wrapper"},[_c('span',{staticClass:"md-display-2",staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.$t('message.pagina_inexistente'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('message.redirecionando_para_home'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }